var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"affixStyle"},[_c('div',{class:{'align-right': true, active: _vm.collapsed, 'is-hidden-menu': _vm.isHiddenMenu}},[_vm._t("button")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }